
import store from "@/store";

const routes = [{
    path: "/operations/inventory/:id",
    name: "warehouseinventory",
    component: () => import('@/views/main/modules/Operations/Inventory/InventoryComponent.vue'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'Warehouse Inventory',
    }
}]

export default routes;
